import { render, staticRenderFns } from "./ManualGroupBuilder.vue?vue&type=template&id=30a41679&"
import script from "./ManualGroupBuilder.vue?vue&type=script&lang=ts&"
export * from "./ManualGroupBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./ManualGroupBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports